// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"193":"0524021d","280":"1932a819","358":"61693440","425":"7b16f005","504":"97e9d769","510":"356fceac","628":"8c4d15dd","815":"faae3635"}[chunkId] + ".chunk.css";
};